import { array, boolean, object, string } from 'yup';

export const createJoinTournamentTeamValidationSchema = (
  maxSize: number,
  withPassphrase: boolean
) => {
  return object().shape({
    name: string().required().max(32).label('Name'),
    passphrase: withPassphrase ? string().required().min(8) : string(),
    players: array().test({
      name: 'players',
      message: `You must have at least ${maxSize} active players.`,
      test: (data) => (data?.length ? data.length === maxSize : false),
    }),
    isRewardBalanceSelected: boolean().optional(),
  });
};
